import { useEffect } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import { FormHeading } from "../../Layouts/Heading";
import { Grid, InputLabel, Switch, TextField } from "@mui/material";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { useDispatch, useSelector } from "react-redux";
import {
    CreateNewBusiness,
    getAllBusiness,
    resetBusiness,
    UpdateBusiness,
} from "../../Redux/BusSlice/BusSlice";
import { toast } from "react-toastify";
const validationSchema = yup.object({
    title: yup.string("Enter your title").required(" title is required "),
    initial: yup.string("Enter your initial").required("initial is required"),
});
const BusinessForm = ({ data }) => {
    const dispatch = useDispatch();
    const { isBusSuccess, isBusError, isBusLodaing, Busmassage } = useSelector(
        (state) => state.business
    );
    const formik = useFormik({
        initialValues: {
            title: data.title,
            initial: data.initial,
            is_active: Boolean(data.is_active),
        },
        validationSchema: validationSchema,
        onSubmit: (values) => {
            if (!data) {
                dispatch(CreateNewBusiness(values));
            }
            dispatch(UpdateBusiness({ ...values, business_id: data.id }));
        },
    });
    const reset = async () => {
        await dispatch(resetBusiness());
        getAll();
    };
    const getAll = async () => {
        await dispatch(getAllBusiness());
        await dispatch(resetBusiness());
    };
    useEffect(() => {
        if (isBusError) {
            toast.error(Busmassage);
        }
        if (
            isBusSuccess &&
            formik.values.title !== null &&
            formik.values.initial
        ) {
            toast.success("Business updated successfully");
        }
        dispatch(resetBusiness());
    }, [isBusError, Busmassage, isBusSuccess]);

    return (
        <>
            <FormHeading>Edit Business </FormHeading>
            <form onSubmit={formik.handleSubmit}>
                <Grid container spacing={2}>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="title"
                            name="title"
                            label="title"
                            value={formik.values.title}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.title &&
                                Boolean(formik.errors.title)
                            }
                            helperText={
                                formik.touched.title && formik.errors.title
                            }
                        />
                    </Grid>
                    <Grid item mb={2} xs={12} md={6}>
                        <TextField
                            fullWidth
                            id="initial"
                            name="initial"
                            label="Initial"
                            value={formik.values.initial}
                            onChange={formik.handleChange}
                            error={
                                formik.touched.initial &&
                                Boolean(formik.errors.initial)
                            }
                            helperText={
                                formik.touched.initial && formik.errors.initial
                            }
                        />
                    </Grid>
                    <Grid item mb={1} xs={12} md={6}>
                        <InputLabel> Active ? </InputLabel>
                        <Switch
                            id="is_active"
                            name="is_active"
                            checked={formik.values.is_active}
                            onChange={formik.handleChange}
                            inputProps={{ "aria-label": "controlled" }}
                        />
                    </Grid>
                </Grid>

                <PrimaryButton fullWidth type="submit">
                    {isBusLodaing ? "Loading..." : "Edit"}
                </PrimaryButton>
            </form>
        </>
    );
};

export default BusinessForm;
